import { Actor, Engine, Vector, Color, CollisionType, vec } from "excalibur";
import { PerforinZone } from "./PerforinZone";
import { Virus } from "../Virus";

export class PerforinGranule extends Actor {
    private targetPos: Vector;
    private duration: number = 600; // ms to reach target
    private elapsedTime: number = 0;
    private startPos: Vector;
    private peakHeight: number = 100; // Fake 3D arc height
    private onKill: (virus: Virus) => void;

    constructor(x: number, y: number, targetX: number, targetY: number, onKill: (virus: Virus) => void) {
        super({
            pos: vec(x, y),
            radius: 8,
            color: Color.fromHex('#bef264'), // Lime green
            collisionType: CollisionType.PreventCollision, // Doesn't collide while flying
        });
        this.startPos = vec(x, y);
        this.targetPos = vec(targetX, targetY);
        this.onKill = onKill;
    }

    override onPreUpdate(engine: Engine, delta: number): void {
        this.elapsedTime += delta;

        if (this.elapsedTime >= this.duration) {
            this.explode(engine);
            return;
        }

        const t = this.elapsedTime / this.duration; // 0 to 1

        // Linear interpolation for X/Y
        const currentPos = this.startPos.add(this.targetPos.sub(this.startPos).scale(t));

        // Parabolic arc for visual "height" (modifying Y, or we could use specific z-index/scale tricks)
        // Since it's top down, "height" usually means Y-offset (jumping) or scaling. 
        // Let's use scaling to simulate "looming" + slight Y-offset for shadow.
        // Actually, just moving straight is fine, maybe scale up and down.

        const height = Math.sin(t * Math.PI) * this.peakHeight;
        this.scale = vec(1 + height / 100, 1 + height / 100);

        this.pos = currentPos;
    }

    private explode(engine: Engine): void {
        // Spawn the zone
        const zone = new PerforinZone(this.targetPos.x, this.targetPos.y, this.onKill);
        engine.add(zone);

        // Splash effect (particles) could go here

        this.kill();
    }
}
